/**
 * PageShell - Unified Page Wrapper Component
 * 
 * Enforces consistent page backgrounds across the app using surface tokens.
 * Prevents "white page" surprises in dark mode.
 * 
 * Usage:
 *   <PageShell>content</PageShell>
 *   <PageShell variant="contained">content with max-width</PageShell>
 *   <PageShell variant="full" className="custom-class">full width + custom</PageShell>
 * 
 * Variants:
 *   - "full" (default): Full width, no max-width container
 *   - "contained": Centered container with max-w-7xl and padding
 */
import React from "react";

export function PageShell({ 
  children, 
  variant = "full", 
  className = "",
  ...props 
}) {
  const baseClasses = "min-h-screen surface-page";
  
  if (variant === "contained") {
    return (
      <div className={`${baseClasses} ${className}`} {...props}>
        <div className="max-w-7xl mx-auto px-4 py-8">
          {children}
        </div>
      </div>
    );
  }
  
  // Default: full width
  return (
    <div className={`${baseClasses} ${className}`} {...props}>
      {children}
    </div>
  );
}

export default PageShell;
